export class RequestCredencialesExterno {
    usuario:String;
	clave:String;
}

export class RequestCredencialesConvenio {
    usuario:String;
	clave:String;
}

export class AdminCredential {
  usuarioAD:string;
	password:string;
}

export class AdminCredentialUtil {
  idSistema:Number;
  usuarioDominio:string;
	contrasena:string;
}
